(function () {
    'use strict';
    var serviceId = 'geolocationService';

    angular.module('app.services').factory(serviceId, ['$interval', 'common',
        function ($interval, common) {

            var geolocationServiceFactory = {};
            var intervaloId;
            var getLocation = function() {
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function(position) {
                        common.localStorageService.set('latitude', position.coords.latitude);
                        common.localStorageService.set('longitude', position.coords.longitude);                        
                    }, function(error) {
                        console.info("Error al obtener la ubicación: ", error);
                    });
                } else {
                    console.log("La geolocalización no es compatible con este navegador.");
                }
            };

            var init = function(){
                getLocation();
                intervaloId = $interval(getLocation, 20000);
            };

            var destroy = function(){
                $interval.cancel(intervaloId);
            };

            geolocationServiceFactory.init = init;
            geolocationServiceFactory.destroy = destroy;
            
            return geolocationServiceFactory;
        }]);

})();